const schlafconceptDesktop = '/images/references/schlafconcept-desktop';
const harzhuusDesktop = '/images/references/harzhuus-desktop';
const tagesmuttiDesktop = '/images/references/tagesmutti-desktop';
const ushUmweltDesktop = '/images/references/ush-umwelt-desktop';
const yogaAdyaDesktop = '/images/references/yoga-adya-desktop';
const tennisclubDesktop = '/images/references/tennisclub-desktop';
const ballettkinderTicketsDesktop = '/images/references/ballettkinder-tickets-desktop';
const henneckeDesktop = '/images/references/hennecke-desktop';
const bodenstaendigDesktop = '/images/references/bodenstaendig-desktop';
const ballettkinderDesktop = '/images/references/ballettkinder-desktop';
const mtgSteuerDesktop = '/images/references/mtg-steuer-desktop';
const arztpraxisZittauDesktop = '/images/references/arztpraxis-zittau-desktop';
const solehotelsDesktop = '/images/references/solehotels-desktop';
const eggertAlmDesktop = '/images/references/eggert-alm-desktop';
const pensionWernigerodeDesktop = '/images/references/pension-wernigerode-desktop';
const vbsimmoDesktop = '/images/references/vbsimmo-desktop';
const ibHahnDesktop = '/images/references/ib-hahn-desktop';
const elektroGattermannDesktop = '/images/references/elektro-gattermann-desktop';
const gattermannDesktop = '/images/references/gattermann-desktop';
const forsthausImHarzDesktop = '/images/references/forsthaus-im-harz-desktop';
const pasapaDesktop = '/images/references/pasapa-desktop';
const mundwerkDesktop = '/images/references/mundwerk-logopaedie-desktop';
const flywithtoniDesktop = '/images/references/flywithtoni-desktop';

export interface Reference {
  id: string;
  title: string;
  headline: string;
  url: string;
  urlLabel?: string;
  category: string;
  industry: string;
  description: string;
  summary: string;
  image: string;
  screenshotDesktop?: string;
  color: string;
  featured?: boolean;
  // Project Details
  client: string;
  duration: string;
  services: string[];
  // Sections
  challenge: string;
  solution: string;
  result: string;
  resultStats?: { label: string; value: string }[];
  challengePoints: string[];
  approachPoints: string[];
  datePublished?: string;
  dateModified?: string;
}


export const references: Reference[] = [
  {
    id: 'flywithtoni',
    title: 'Fly With Toni – Take Off Gin',
    headline: 'Rechtssicherer WooCommerce-Shop mit automatisiertem DHL-Versand für den Gin von Toni Eggert',
    url: 'https://www.flywithtoni.com/',
    category: 'E-Commerce',
    industry: 'Unternehmen & B2B',
    description: 'Online-Shop für den Take Off Gin von Sportler und Pilot Toni Eggert – umgesetzt mit WordPress und WooCommerce, rechtssicher für den deutschen Markt.',
    summary: 'WordPress-Shop mit Germanized Pro, DHL-Versandlabels über Shiptastic, PayPal und Kreditkarte, Wordfence-Absicherung und Shop-Anleitungen für den Kunden.',
    image: flywithtoniDesktop,
    screenshotDesktop: flywithtoniDesktop,
    color: 'from-sky-600 to-blue-700',
    featured: true,
    client: 'Fly With Toni – Toni Eggert',
    duration: '7 Wochen',
    services: ['E-Commerce', 'WordPress/WooCommerce', 'Zahlungsintegration', 'Versandautomatisierung', 'Sicherheit', 'Schulung & Anleitungen'],
    challenge: 'Toni Eggert wollte seinen eigenen Gin direkt online verkaufen. Beim Verkauf von Alkohol in Deutschland gelten strenge Pflichtangaben – Grundpreis, Lebensmittelinformationen, Lieferzeiten, Widerruf. Gleichzeitig sollte der Shop sicher laufen und sich ohne Agentur im Alltag bedienen lassen.',
    solution: 'In Zusammenarbeit mit einer Berliner Agentur, die die Bildwelt geliefert hat, haben wir den Shop mit WordPress und WooCommerce umgesetzt. Germanized Pro ist nach rechtlichen Vorgaben konfiguriert (Grundpreis, MwSt., Lieferzeit, Lebensmittelangaben, Rechtstexte). DHL-Versandlabels werden über Shiptastic automatisch erzeugt, Bestell- und Versandmails laufen automatisiert. Bezahlt wird per PayPal oder Kreditkarte. Wordfence Security schützt den Shop, Zugriffszahlen werden überwacht und ein Consent-Banner sorgt für DSGVO-konformes Tracking. Zum Abschluss haben wir Shop-Anleitungen erstellt, damit sich der Kunde selbstständig zurechtfindet.',
    result: 'Fly With Toni verkauft seinen Gin jetzt rechtssicher und weitgehend automatisiert online – vom Warenkorb über die Zahlung bis zum fertigen DHL-Label. Bestell-, Rechnungs- und Versanddaten liegen sauber und einheitlich vor, dadurch bleibt die Abrechnung für den Steuerberater einfach. Dank der Anleitungen pflegt der Kunde Produkte und Bestellungen selbst.',
    resultStats: [
      { label: 'Automatisierung', value: 'DHL-Labels & PayPal' },
      { label: 'Abrechnung für Steuerberater', value: 'leicht gemacht' },
      { label: 'Shop-Pflege', value: 'ganz ohne Agentur' },
    ],
    approachPoints: ['Germanized Pro rechtssicher konfiguriert', 'DHL-Labels via Shiptastic', 'PayPal & Kreditkarte', 'Wordfence Security & Monitoring', 'Automatisierte E-Mails', 'Shop-Anleitungen für den Kunden'],
    challengePoints: ['Strenge Pflichtangaben beim Alkoholverkauf', 'Manueller Versandaufwand', 'Shop selbst pflegen können'],
    datePublished: '2026-10-17',
    dateModified: '2026-10-17',
  },
  {
    id: 'mundwerk-logopaedie',
    title: 'Mundwerk – Logopädie im Harz',
    headline: 'Moderne Praxiswebseite mit Hintergrundvideo, Bewerber-Funnel und datenschutzfreundlicher Instagram-Einbindung',
    url: 'https://www.mundwerk-logopaedie.com/',
    category: 'Logopädie',
    industry: 'Gesundheit & Wellness',
    description: 'Komplett neu gestaltete Webseite für die Logopädie-Praxis Mundwerk in Wernigerode und Quedlinburg – mit Video- und Foto-Integration, Animationen und starker Karriereseite.',
    summary: 'Emotionaler Auftritt mit Hintergrundvideo, Bewerber-Funnel, eingebundenen Praxisfotos und Instagram-Feed ohne Datenübertragung an Instagram.',
    image: mundwerkDesktop,
    screenshotDesktop: mundwerkDesktop,
    color: 'from-amber-500 to-orange-500',
    featured: true,
    client: 'Mundwerk – Die Praxis für Logopädie & Schluckambulanz',
    duration: '6 Wochen',
    services: ['Webdesign', 'Foto- & Video-Integration', 'Bewerber-Funnel', 'Local SEO', 'Karriereseite', 'Hosting/Betrieb'],
    challenge: 'Die bisherige Webseite wirkte veraltet, zeigte kaum echte Einblicke in die Praxis und half wenig bei der Suche nach neuen Fachkräften. Gerade im Wettbewerb um Logopädinnen und Logopäden fehlte ein Auftritt, der das Team und die Arbeitsbedingungen überzeugend vermittelt.',
    solution: 'Wir haben das Layout komplett neu aufgebaut – mit Hintergrundvideo und den vorhandenen Praxisfotos, die wir nahtlos in das Design integriert haben, plus dezenten Animationen. Ein mehrstufiger Bewerber-Funnel macht die Bewerbung in wenigen Klicks möglich, die Karriereseite liefert alle wichtigen Infos und Stimmen aus dem Team. Der Instagram-Feed ist eingebunden – datenschutzfreundlich, denn beim Seitenaufruf wird nichts von Instagram geladen. Dazu kamen neue Inhalte zu Leistungen und Schluckambulanz sowie eine Local-SEO-Optimierung für die Standorte Wernigerode und Quedlinburg.',
    result: 'Mundwerk präsentiert sich jetzt modern, nahbar und professionell. Patienten finden schnell die passende Leistung, und Bewerber erhalten ein klares Bild vom Team – mit einem einfachen Weg zur Bewerbung. Die Seite lädt deutlich schneller und ist dank Local SEO besser in den regionalen Suchergebnissen auffindbar.',
    resultStats: [
      { label: 'Bewerbung', value: 'in 2 Min.' },
      { label: 'Local SEO', value: 'Integriert' },
      { label: 'Ladezeit', value: 'Deutlich schneller' },
    ],
    approachPoints: ['Hintergrundvideo & Fotos integriert', 'Bewerber-Funnel', 'Ausgebaute Karriereseite', 'Instagram ohne Tracking', 'Local SEO für Wernigerode & Quedlinburg'],
    challengePoints: ['Veraltetes Layout', 'Fachkräftemangel', 'Wenig echte Einblicke'],
    datePublished: '2026-10-17',
    dateModified: '2026-10-17',
  },
  {
    id: 'solehotels',
    title: 'Solehotels Bad Harzburg',
    headline: 'Exklusive Hotelwebseite für Wellness und Erholung im Harz',
    url: 'https://www.solehotels.de/',
    category: 'Hotel',
    industry: 'Tourismus',
    description: 'Historische Solehotels in Bad Harzburg – Wellness, Erholung und Genuss in einzigartiger Atmosphäre.',
    summary: 'Elegante Hotelwebseite mit Buchungsintegration und emotionaler Bildsprache für ein exklusives Wellnesshotel.',
    image: solehotelsDesktop,
    screenshotDesktop: solehotelsDesktop,
    color: 'from-amber-700 to-yellow-600',
    featured: true,
    client: 'Solehotels Bad Harzburg',
    duration: '3 Monate',
    services: ['Webdesign', 'Buchungsintegration', 'SEO', 'Content-Strategie', 'Hosting/Betrieb'],
    challenge: 'Die bestehende Webseite spiegelte nicht die exklusive Atmosphäre der historischen Solehotels wider. Die Buchungsintegration war veraltet und die mobile Nutzererfahrung suboptimal.',
    solution: 'Wir entwickelten eine elegante, moderne Webseite, die die besondere Geschichte und Atmosphäre der Hotels transportiert. Großzügige Bildergalerien, emotionale Texte und eine nahtlose Buchungsintegration laden zum Verweilen und Buchen ein.',
    result: 'Die neue Webseite vermittelt erfolgreich das einzigartige Hotelerlebnis. Die Direktbuchungen haben zugenommen und Gäste schwärmen vom stimmigen Online-Auftritt.',
    resultStats: [
      { label: 'Mehr Direktbuchungen', value: '+65%' },
      { label: 'Mobile Nutzer', value: '75%' },
      { label: 'Verweildauer', value: '4 Min.' },
    ],
    approachPoints: ['Emotionale Bildsprache', 'Nahtlose Buchungsintegration', 'Mobile Optimierung'],
    challengePoints: ['Veraltete Webpräsenz', 'Unbefriedigende Nutzerführung', 'Technische Defizite'],
  },
  {
    id: 'vbsimmo',
    title: 'VBS IMMO – Harzer Volksbank & Sallier',
    headline: 'Umfangreicher Immobilienauftritt mit FIO-Integration für regionalen Makler',
    url: 'https://www.vbsimmo.de/',
    category: 'Immobilien',
    industry: 'Immobilien',
    description: 'Harzer Volksbank & Sallier Immobilien GmbH – Ihr regionaler Immobilienpartner im Harz mit umfassendem Leistungsspektrum.',
    summary: 'Große WordPress-Webseite mit 25 Unterseiten und Immobilienintegration über FIO/OpenImmo-Standard für einen regionalen Immobilienmakler.',
    image: vbsimmoDesktop,
    screenshotDesktop: vbsimmoDesktop,
    color: 'from-blue-600 to-orange-500',
    featured: true,
    client: 'Harzer Volksbank & Sallier Immobilien GmbH',
    duration: '4 Monate',
    services: ['Webdesign', 'WordPress & Elementor', 'FIO-Integration (OpenImmo)', 'Frymo Plugin', 'SEO', 'Hosting/Betrieb'],
    challenge: 'Als etablierter Immobilienmakler im Harz fehlte ein moderner, umfassender Webauftritt, der die Immobilienobjekte automatisiert aus dem FIO-System übernimmt und ansprechend präsentiert. Die bestehende Lösung war veraltet und bot keine zeitgemäße Objektsuche.',
    solution: 'Wir entwickelten eine umfangreiche WordPress-Webseite mit Elementor und 25 Unterseiten. Über das Frymo Plugin wurde eine nahtlose Immobilienintegration aus FIO über den OpenImmo-Standard realisiert. Objekte werden automatisch synchronisiert und mit Suchfiltern für Ort, Objekttyp und Kauf/Miete dargestellt.',
    result: 'Der neue Webauftritt positioniert VBS IMMO als modernen Immobilienpartner im Harz. Die automatisierte Objektsynchronisation spart erheblich Zeit und die komfortable Immobiliensuche verbessert die Nutzererfahrung deutlich.',
    resultStats: [
      { label: 'Unterseiten', value: '25+' },
      { label: 'Objektsynchronisation', value: 'Automatisch' },
      { label: 'Ladezeit', value: '< 3s' },
    ],
    approachPoints: ['FIO/OpenImmo-Integration', 'WordPress mit Elementor', 'Komfortable Immobiliensuche', 'Responsive Design'],
    challengePoints: ['Veralteter Webauftritt', 'Manuelle Objektpflege', 'Fehlende Suchfunktion'],
  },
  {
    id: 'arztpraxis-zittau',
    title: 'Gemeinschaftspraxis Pätzold & Čížková',
    headline: 'Moderner Praxisauftritt für eine Hausarztpraxis in Zittau',
    url: 'https://www.arztpraxis-zittau.de/',
    category: 'Arztpraxis',
    industry: 'Gesundheit & Wellness',
    description: 'Hausarztpraxis in Zittau mit Schwerpunkten Prävention, Diagnostik und hausärztliche Versorgung. Moderne Ausstattung und patientenorientierter Service.',
    summary: 'Zeitgemäße Praxiswebseite mit klarer Leistungsübersicht und einladendem Design für eine vertrauensvolle Patientenansprache.',
    image: arztpraxisZittauDesktop,
    screenshotDesktop: arztpraxisZittauDesktop,
    color: 'from-pink-600 to-purple-600',
    featured: true,
    client: 'Gemeinschaftspraxis Pätzold & Čížková',
    duration: '2 Monate',
    services: ['Webdesign', 'Content-Erstellung', 'SEO', 'DSGVO-Konformität', 'Hosting/Betrieb'],
    challenge: 'Vor dem Projekt gab es keinen Webauftritt. Patienten fanden wichtige Informationen nur telefonisch oder vor Ort – Leistungen, Sprechzeiten und Kontaktwege waren online nicht sichtbar.',
    solution: 'Wir entwickelten den ersten modernen, einladenden Praxisauftritt mit frischem Farbkonzept in Rosa und Blau. Die Leistungen Prävention, Diagnostik und hausärztliche Versorgung werden mit ansprechenden Icons präsentiert. Das Team wird persönlich vorgestellt, was Vertrauen schafft. Zusätzlich wurden wichtige Service-Themen klar herausgestellt: Rezeptbestellung (E‑Rezept), Überweisungsanforderung sowie Hinweise zu Ablauf, Karte und Abholung.',
    result: 'Die Praxis präsentiert sich nun zeitgemäß und professionell. Patienten können sich vorab umfassend über das Leistungsangebot informieren, finden alle wichtigen Kontaktdaten auf einen Blick und verstehen die Anforderungen für E‑Rezept und Überweisung.',
    resultStats: [
      { label: 'Moderne Präsenz', value: '100%' },
      { label: 'Mobile Optimierung', value: '100%' },
      { label: 'Ladezeit', value: '< 2s' },
    ],
    approachPoints: ['Klare Leistungsdarstellung', 'Vertrauenswürdiges Design', 'E‑Rezept- und Überweisungsprozess erklärt', 'DSGVO-Konformität'],
    challengePoints: ['Kein Webauftritt', 'Keine digitale Auffindbarkeit', 'Keine zentrale Leistungsübersicht'],
  },
  {
    id: 'mtg-steuer',
    title: 'MTG Steuerberatungsgesellschaft',
    headline: 'Regionale Sichtbarkeit für Steuerexperten mit 6 Standorten',
    url: 'https://mtg-steuer.de/',
    category: 'Steuerberatung',
    industry: 'Unternehmen & B2B',
    description: 'Etablierte Steuerberatungsgesellschaft mit über 20 Jahren Erfahrung und 6 Standorten in Sachsen-Anhalt. 50+ ausgebildete Fachkräfte.',
    summary: 'Standortübergreifende SEO-Optimierung und regelmäßige Content-Updates für nachhaltig steigende Besucherzahlen.',
    image: mtgSteuerDesktop,
    screenshotDesktop: mtgSteuerDesktop,
    color: 'from-blue-700 to-blue-900',
    featured: true,
    client: 'MTG Steuerberatungsgesellschaft mbH',
    duration: 'Laufende Betreuung',
    services: ['SEO-Optimierung', 'Newsletter-Versand', 'Content-Updates', 'Standort-SEO', 'Hosting/Betrieb'],
    challenge: 'Mit 6 Standorten in Sachsen-Anhalt war es eine Herausforderung, bei lokalen Suchanfragen für jeden einzelnen Standort sichtbar zu sein. Der Content auf der Website wurde nur selten aktualisiert und der Newsletter-Versand war unregelmäßig.',
    solution: 'Wir implementierten eine standortbasierte SEO-Strategie, bei der jeder Standort für lokale Suchbegriffe optimiert wurde. Durch regelmäßige Content-Updates zu Steuerthemen bleibt die Website aktuell und relevant. Der professionelle Newsletter-Versand informiert Mandanten über wichtige Steueränderungen.',
    result: 'Die Besucherzahlen sind merklich gestiegen. Alle 6 Standorte ranken nun für lokale Suchanfragen und der Newsletter erreicht Mandanten zuverlässig mit relevanten Informationen.',
    resultStats: [
      { label: 'Mehr Besucher', value: '+85%' },
      { label: 'Standorte optimiert', value: '6' },
      { label: 'Newsletter-Öffnungsrate', value: '42%' },
    ],
    approachPoints: ['Standortbasierte SEO', 'Regelmäßige Content-Updates', 'Newsletter-Marketing'],
    challengePoints: ['Mehrere Standorte unoptimiert', 'Veraltete Inhalte', 'Unregelmäßige Kommunikation'],
  },
  {
    id: 'tagesmutti',
    title: 'Tagesmutti Eisleben',
    headline: 'Vertrauensvolle Online-Präsenz für liebevolle Kinderbetreuung',
    url: 'https://www.tagesmutti-eisleben.de/',
    category: 'Kinderbetreuung',
    industry: 'Soziales & Vereine',
    description: 'Liebevolle Kindertagespflege in Eisleben für Kinder von 0-4 Jahren. Kindgerechte Räume, gesunde Ernährung und individuelle Entwicklungsbegleitung.',
    summary: 'Warmherzige Webseite, die Eltern Vertrauen schenkt und den Alltag in der Kindertagespflege erlebbar macht.',
    image: tagesmuttiDesktop,
    screenshotDesktop: tagesmuttiDesktop,
    color: 'from-pink-500 to-rose-500',
    featured: false,
    client: 'Tagesmutti Eisleben',
    duration: '6 Wochen',
    services: ['Webdesign', 'Content-Erstellung', 'Fotografie-Beratung', 'Hosting/Betrieb'],
    challenge: 'Als selbstständige Tagesmutter fehlte eine professionelle Online-Präsenz. Eltern konnten sich kein Bild von den Räumlichkeiten und dem pädagogischen Konzept machen. Die Anfragen kamen nur über Mundpropaganda.',
    solution: 'Wir gestalteten eine warmherzige, vertrauenserweckende Webseite mit vielen Einblicken in den Alltag. Das pädagogische Konzept und die Räumlichkeiten werden liebevoll präsentiert. Ein einfaches Kontaktformular ermöglicht schnelle Anfragen.',
    result: 'Eltern können sich nun online ein umfassendes Bild machen. Die Anfragen haben zugenommen und die Tagesmutter wird als professionelle Betreuungseinrichtung wahrgenommen.',
    resultStats: [
      { label: 'Neue Anfragen', value: '+80%' },
      { label: 'Vollauslastung', value: '100%' },
      { label: 'Warteliste', value: '6 Mon.' },
    ],
    approachPoints: ['Warmherziges Design', 'Authentische Inhalte', 'Einfaches Kontaktformular'],
    challengePoints: ['Keine Online-Präsenz', 'Vertrauen schwer zu vermitteln', 'Mangelnde Sichtbarkeit'],
  },
  {
    id: 'schlafconcept',
    title: 'Schlafconcept Erfurt',
    headline: 'Wie wir Schlafconcept zur führenden Schlafberatung in Thüringen machten',
    url: 'https://www.schlafconcept.de/',
    category: 'E-Commerce',
    industry: 'Unternehmen & B2B',
    description: 'Zertifizierte Schlafberatung mit mobiler Liegeanalyse. Individuelle Lösungen für erholsamen Schlaf, abgestimmt auf Körperhaltung und Gesundheit.',
    summary: 'Moderner E-Commerce-Auftritt mit integriertem Buchungssystem für mobile Schlafberatung – für mehr Reichweite und Kundenanfragen.',
    image: schlafconceptDesktop,
    screenshotDesktop: schlafconceptDesktop,
    featured: true,
    color: 'from-indigo-600 to-purple-600',
    client: 'Schlafconcept Erfurt',
    duration: '3 Monate',
    services: ['Webdesign', 'E-Commerce', 'Buchungssystem', 'SEO', 'Hosting/Betrieb'],
    challenge: 'Die bisherige Webseite war veraltet und nicht mobiloptimiert. Kunden konnten keine Termine online buchen und die Sichtbarkeit bei Google war minimal. Das Team verlor potenzielle Kunden an die Konkurrenz.',
    solution: 'Wir entwickelten eine moderne, mobiloptimierte Webseite mit integriertem Online-Buchungssystem. Durch gezielte SEO-Maßnahmen verbesserten wir die lokale Sichtbarkeit. Das Design vermittelt Ruhe und Professionalität – passend zum Thema Schlaf.',
    result: 'Die neue Webseite generiert nun konstant Online-Buchungen. Die Sichtbarkeit bei Google hat sich deutlich verbessert und das Unternehmen wird als moderne, professionelle Schlafberatung wahrgenommen.',
    resultStats: [
      { label: 'Mehr Anfragen', value: '+150%' },
      { label: 'Mobile Nutzer', value: '70%' },
      { label: 'Ladezeit', value: '< 2s' },
    ],
    approachPoints: ['E-Commerce-Integration', 'Online-Buchungssystem', 'Beruhigendes Design'],
    challengePoints: ['Unmoderne Webseite', 'Keine Online-Buchung', 'Schlechte Google-Sichtbarkeit'],
  },
  {
    id: 'harzhuus',
    title: 'Harzhuus Apartments',
    headline: 'Buchungssteigerung um 200% für Ferienwohnungen im Harz',
    url: 'https://www.harzhuus-apartments.de/',
    category: 'Ferienwohnungen',
    industry: 'Tourismus',
    description: 'Stilvolle Ferienwohnungen im historischen Zanthierhaus in Ilsenburg am Fuße des Brockens. Mit Balkon und Waldblick.',
    summary: 'Emotionale Webpräsenz mit nahtloser Buchungsintegration für exklusive Ferienwohnungen im Harz.',
    image: harzhuusDesktop,
    screenshotDesktop: harzhuusDesktop,
    color: 'from-emerald-600 to-teal-600',
    client: 'Harzhuus Apartments',
    duration: '2 Monate',
    services: ['Webdesign', 'Buchungsintegration', 'Fotografie-Konzept', 'SEO', 'Hosting/Betrieb'],
    challenge: 'Die Ferienwohnungen wurden hauptsächlich über Booking.com vermarktet, was hohe Provisionen bedeutete. Eine eigene Webpräsenz existierte nicht und Direktbuchungen waren kaum möglich.',
    solution: 'Wir erstellten eine emotionale Webseite mit großflächigen Bildern, die das Harz-Feeling transportieren. Die Integration des Buchungssystems ermöglicht provisionsfreie Direktbuchungen. Lokale SEO sorgt für Sichtbarkeit bei Harz-Suchenden.',
    result: 'Die Direktbuchungen haben sich verdreifacht, die Abhängigkeit von Booking.com wurde reduziert. Die Webseite vermittelt erfolgreich die einzigartige Atmosphäre der Apartments.',
    resultStats: [
      { label: 'Mehr Direktbuchungen', value: '+200%' },
      { label: 'Provisionen gespart', value: '15%' },
      { label: 'Google-Ranking', value: 'Top 5' },
    ],
    approachPoints: ['Emotionale Bildsprache', 'Provisionsfreie Direktbuchung', 'Lokale SEO-Optimierung'],
    challengePoints: ['Abhängigkeit von OTAs', 'Hohe Provisionskosten', 'Keine Markenpräsenz'],
  },
  {
    id: 'ush-umwelt',
    title: 'USH Umweltservice Hettstedt',
    headline: 'Professioneller Webauftritt für Umweltdienstleister',
    url: 'https://www.ush-umwelt.de/',
    category: 'Umweltdienstleistung',
    industry: 'Unternehmen & B2B',
    description: 'Akkreditierter Umweltservice mit Expertise in Recycling und Ingenieurwesen. Maßgeschneiderte Lösungen für nachhaltige Umweltprojekte.',
    summary: 'Seriöser B2B-Webauftritt, der Kompetenz und Zuverlässigkeit im Umweltsektor kommuniziert.',
    image: ushUmweltDesktop,
    screenshotDesktop: ushUmweltDesktop,
    color: 'from-green-600 to-emerald-600',
    client: 'USH Umweltservice Hettstedt GmbH',
    duration: '2,5 Monate',
    services: ['Webdesign', 'Corporate Design', 'SEO', 'Content-Strategie', 'Hosting/Betrieb'],
    challenge: 'Die bestehende Webseite war technisch veraltet und spiegelte nicht die Expertise des Unternehmens wider. B2B-Kunden konnten das Leistungsspektrum nicht schnell erfassen.',
    solution: 'Wir entwickelten einen klaren, professionellen Webauftritt mit strukturierter Darstellung aller Dienstleistungen. Referenzprojekte und Zertifizierungen werden prominent präsentiert, um Vertrauen bei B2B-Kunden aufzubauen.',
    result: 'Das Unternehmen wird nun als moderner, kompetenter Partner wahrgenommen. Die Webseite unterstützt aktiv den Vertrieb bei der Neukundengewinnung.',
    resultStats: [
      { label: 'B2B-Anfragen', value: '+120%' },
      { label: 'Verweildauer', value: '4 Min.' },
      { label: 'Seiten/Besuch', value: '5+' },
    ],
    approachPoints: ['Professionelle Struktur', 'Referenzen prominent', 'Zertifizierungen hervorgehoben'],
    challengePoints: ['Veraltete Technik', 'Fehlende Kompetenzdarstellung', 'Schlechte Kundengewinnung'],
  },
  {
    id: 'yoga-adya',
    title: 'Yoga Adya Wernigerode',
    headline: 'Digitale Ruhe-Oase für ein erfolgreiches Yogastudio',
    url: 'https://www.yoga-adya.de/',
    category: 'Yoga-Studio',
    industry: 'Gesundheit & Wellness',
    description: 'Wunderschönes Yogastudio in Wernigerode und Blankenburg mit Hatha Yoga, Yin Yoga, Schwangerschaftsyoga und mehr.',
    summary: 'Harmonische Webpräsenz mit integriertem Kursbuchungssystem, die die Atmosphäre des Studios online erlebbar macht.',
    image: yogaAdyaDesktop,
    screenshotDesktop: yogaAdyaDesktop,
    color: 'from-purple-500 to-violet-600',
    client: 'Yoga Adya',
    duration: '4 Monate',
    services: ['Webdesign', 'Eversports-Integration', 'SEO', 'Social-Media-Integration', 'Hosting/Betrieb'],
    challenge: 'Die Kursanmeldung lief ausschließlich per Telefon und E-Mail. Interessenten konnten online weder Kurszeiten einsehen noch buchen. Die alte Webseite transportierte nicht die besondere Atmosphäre des Studios.',
    solution: 'Wir schufen eine ruhige, meditative Webpräsenz mit sanften Farben und fließenden Animationen. Durch die nahtlose Integration von Eversports können Teilnehmer direkt online Kurse buchen und bezahlen. Die Kursbeschreibungen wurden optimiert für Yoga-Einsteiger.',
    result: 'Die Online-Buchungen machen mittlerweile 70% aller Anmeldungen aus. Das Studio hat seine Reichweite erweitert und neue Zielgruppen erschlossen.',
    resultStats: [
      { label: 'Online-Buchungen', value: '70%' },
      { label: 'Neue Kursteilnehmer', value: '+60%' },
      { label: 'Google-Bewertung', value: '5.0 ⭐' },
    ],
    approachPoints: ['Meditative Ästhetik', 'Eversports-Integration', 'Anfängerfreundliche Texte'],
    challengePoints: ['Keine Online-Buchung', 'Mangelhafte Kursdarstellung', 'Geringe Reichweite'],
  },
  {
    id: 'tennisclub',
    title: 'Tennisclub Wernigerode',
    headline: 'Moderner Webauftritt für einen traditionsreichen Sportverein',
    url: 'https://www.tennisclub-wernigerode.de/',
    category: 'Sportverein',
    industry: 'Soziales & Vereine',
    description: 'Traditionsreicher Tennisclub seit 1920 mit 6 Plätzen. Familienfreundlicher Verein mit Kinder- und Jugendtraining.',
    summary: 'Frischer Vereinsauftritt mit zentraler Mitarbeiter- und Vereinskommunikation für einen der ältesten Tennisclubs der Region.',
    image: tennisclubDesktop,
    screenshotDesktop: tennisclubDesktop,
    color: 'from-lime-500 to-green-600',
    client: 'Tennisclub Wernigerode e.V.',
    duration: '3 Monate',
    services: ['Webdesign', 'Mitgliederbereich', 'Interne Kommunikation', 'Vereinssoftware', 'Hosting/Betrieb'],
    challenge: 'Informationen für Mitarbeitende und Vereinsgremien waren über verschiedene Kanäle verteilt. Neue Mitglieder fanden kaum strukturierte Einblicke in den Verein. Der Webauftritt wirkte nicht zeitgemäß für einen Club mit so langer Tradition.',
    solution: 'Wir entwickelten eine moderne Vereinswebseite mit geschütztem Bereich für interne Kommunikation und zentralen Inhalten. Die Geschichte des Vereins bleibt sichtbar, zugleich wirkt der Auftritt klar, aktuell und gut strukturiert.',
    result: 'Die interne Abstimmung ist effizienter, wichtige Informationen sind schneller auffindbar. Der Verein wirkt nach außen professionell und gewinnt leichter neue Interessierte.',
    resultStats: [
      { label: 'Neue Mitglieder', value: '+25%' },
      { label: 'Interne Zugriffe', value: '+60%' },
      { label: 'Admin-Aufwand', value: '-40%' },
    ],
    approachPoints: ['Zentrale Kommunikation', 'Mitgliederbereich', 'Tradition + Modernität'],
    challengePoints: ['Verstreute Infos', 'Kein zentraler Austausch', 'Unzeitgemäße Webpräsenz'],
  },
  {
    id: 'pension-wernigerode',
    title: 'Pension Wernigerode',
    headline: 'Gemütlichkeit digital erlebbar machen',
    url: 'https://www.pension-in-wernigerode.de/',
    category: 'Pension',
    industry: 'Tourismus',
    description: 'Gemütliche Pension im Herzen von Wernigerode. Idealer Ausgangspunkt für Erkundungen im Harz.',
    summary: 'Einladende Webpräsenz für eine familiengeführte Pension mit direkter Buchungsmöglichkeit.',
    image: pensionWernigerodeDesktop,
    screenshotDesktop: pensionWernigerodeDesktop,
    color: 'from-amber-500 to-orange-600',
    client: 'Pension Wernigerode',
    duration: '6 Wochen',
    services: ['Webdesign', 'Buchungsintegration', 'Lokales SEO', 'Google Business', 'Hosting/Betrieb'],
    challenge: 'Die Pension war auf Buchungsportalen gelistet, hatte aber keine eigene ansprechende Webseite. Gäste konnten sich kein Bild von der persönlichen Atmosphäre machen.',
    solution: 'Wir erstellten eine einladende Webseite, die die familiäre Atmosphäre transportiert. Zimmerfotos, Ausstattungsdetails und Ausflugstipps laden zum Stöbern ein. Die Buchungsintegration ermöglicht provisionsfreie Direktbuchungen.',
    result: 'Die Direktbuchungsquote hat sich verdoppelt. Gäste loben die informativen Ausflugstipps und kommen besser vorbereitet an.',
    resultStats: [
      { label: 'Direktbuchungen', value: '+100%' },
      { label: 'Weiterempfehlungen', value: '95%' },
      { label: 'Stammgäste', value: '+40%' },
    ],
    approachPoints: ['Familiäre Atmosphäre zeigen', 'Ausflugstipps integrieren', 'Provisionsfreie Buchung'],
    challengePoints: ['Abhängigkeit von Portalen', 'Keine Eigenpräsentation', 'Hohe Gebühren'],
  },
  {
    id: 'hennecke',
    title: 'Gemeinschaftspraxis Hennecke',
    headline: 'Digitale Praxispräsenz für zeitgemäße Patientenkommunikation',
    url: 'https://gemeinschaftspraxis-hennecke.de/',
    category: 'Arztpraxis',
    industry: 'Gesundheit & Wellness',
    description: 'Fachärzte für Allgemeinmedizin in Ilsenburg/Harz. E-Rezept-fähig, Prävention und apparative Diagnostik.',
    summary: 'Professionelle Praxiswebseite mit klaren Patienteninformationen, Kontaktformular und Rezeptbestellung für moderne Patientenkommunikation.',
    image: henneckeDesktop,
    screenshotDesktop: henneckeDesktop,
    color: 'from-rose-500 to-pink-600',
    client: 'Gemeinschaftspraxis Hennecke',
    duration: '2 Monate',
    services: ['Webdesign', 'Patienteninformationen', 'Kontaktformular', 'Rezeptbestellung', 'SEO', 'Hosting/Betrieb'],
    challenge: 'Patienten fanden wichtige Infos zu Leistungen, Sprechzeiten und Rezepten nur verstreut. Anfragen liefen überwiegend telefonisch und banden unnötig Zeit im Praxisalltag.',
    solution: 'Wir entwickelten eine klare Praxiswebseite mit strukturierten Patienteninformationen, gut sichtbarem Kontaktformular und einer einfachen Rezeptbestellung. E-Rezept-Infos und Hinweise für Neupatienten sind prominent platziert.',
    result: 'Patienten finden relevante Informationen schneller, Anfragen laufen strukturierter und die Rezeptbestellung ist deutlich effizienter.',
    resultStats: [
      { label: 'Kontaktanfragen', value: '+45%' },
      { label: 'Rezeptanfragen', value: '70% online' },
      { label: 'Telefonentlastung', value: '-30%' },
    ],
    approachPoints: ['Patienteninformationen', 'Kontaktformular', 'Rezeptbestellung'],
    challengePoints: ['Verstreute Infos', 'Hoher Telefonaufwand', 'Unklare Kontaktwege'],
  },
  {
    id: 'ib-hahn',
    title: 'Ingenieurbüro Dipl.-Ing. (FH) M. Hahn',
    headline: 'Gründungsneustart mit klarer B2B-Präsenz für Geotechnik und konstruktiven Ingenieurbau',
    url: 'https://www.ib-hahn.de/',
    category: 'Ingenieurbüro',
    industry: 'Unternehmen & B2B',
    description: 'Ingenieurbüro in Wernigerode für Geotechnik, Spezialtiefbau, Betontechnologie, Injektionstechnik und Ingenieurvermessung.',
    summary: 'Moderner Erstauftritt für ein Ingenieurbüro in Wernigerode, umgesetzt mit React für starke Performance und saubere SEO-Basis inklusive Sitemap, Kontaktformular mit Resend sowie Cloudflare Turnstile als Spam-Schutz.',
    image: ibHahnDesktop,
    screenshotDesktop: ibHahnDesktop,
    color: 'from-slate-700 to-cyan-700',
    client: 'Ingenieurbüro Dipl.-Ing. (FH) M. Hahn | Wernigerode',
    duration: '2 Wochen',
    services: [
      'Webdesign',
      'React-Umsetzung & Performance',
      'SEO-Grundlagen & Sitemap',
      'Kontaktformular mit Resend',
      'Cloudflare Turnstile',
      'Hosting/Betrieb',
    ],
    challenge: 'Zum Gründungsneustart gab es noch keine Website. Für das Ingenieurbüro fehlte damit jede digitale Grundlage, um Leistungen, Fachgebiete und Kontaktmöglichkeiten professionell zu präsentieren. Gerade im B2B-Umfeld war ein klarer, vertrauenswürdiger Erstauftritt entscheidend.',
    solution: 'Wir entwickelten einen modernen, seriösen Webauftritt mit Fokus auf Geotechnik und konstruktiven Ingenieurbau. Die Seite wurde mit React für schnelle Ladezeiten und eine saubere technische Basis umgesetzt. Zusätzlich haben wir eine SEO-Grundlage mit Sitemap aufgebaut sowie ein Kontaktformular integriert, das im Hintergrund über Resend versendet und durch Cloudflare Turnstile gegen Spam abgesichert wird.',
    result: 'Das Ingenieurbüro verfügt nun vom Start weg über eine professionelle B2B-Webpräsenz. Die Leistungen sind klar strukturiert auffindbar, die Website ist technisch sauber aufgestellt und Kontaktanfragen können direkt digital übermittelt werden.',
    resultStats: [
      { label: 'Auffindbarkeit', value: 'Sichtbar im Netz' },
      { label: 'Ladezeiten', value: 'Unter 1 Sekunde' },
      { label: 'Anfragen', value: 'Direkt digital möglich' },
    ],
    approachPoints: [
      'Klarer B2B-Auftritt für Ingenieurleistungen',
      'React-Umsetzung für Performance und Wartbarkeit',
      'SEO-Basis mit sauberer Sitemap',
      'Kontaktformular mit Resend und Cloudflare Turnstile',
    ],
    challengePoints: [
      'Keine bestehende Website',
      'Gründungsneustart ohne digitale Präsenz',
      'Leistungen und Kontaktwege nicht online sichtbar',
    ],
    datePublished: '2026-03-22',
    dateModified: '2026-03-22',
  },
  {
    id: 'bodenstaendig',
    title: 'Bodenständig Polenz',
    headline: 'Handwerkskunst professionell präsentiert',
    url: 'https://bodenstaendig-polenz.de/',
    category: 'Handwerk',
    industry: 'Unternehmen & B2B',
    description: 'Fußbodentechnik und Gebäudereinigung seit 2021. Über 9 Jahre Erfahrung mit Teppich, Laminat, Designbelägen und Vinyl.',
    summary: 'Überzeugende Handwerker-Webseite mit Referenzgalerie und Online-Terminvereinbarung mit Calendly für regionale Kunden.',
    image: bodenstaendigDesktop,
    screenshotDesktop: bodenstaendigDesktop,
    color: 'from-stone-600 to-zinc-700',
    client: 'Bodenständig Polenz',
    duration: '5 Wochen',
    services: ['Webdesign', 'Referenzgalerie', 'Online-Terminvereinbarung (Calendly)', 'Buchungssysteme', 'Lokales SEO', 'Hosting/Betrieb'],
    challenge: 'Als neues Unternehmen war die Online-Sichtbarkeit gering. Potenzielle Kunden konnten keine Referenzen einsehen und Termine mussten telefonisch abgestimmt werden.',
    solution: 'Wir entwickelten eine klare, vertrauenerweckende Webseite mit großzügiger Referenzgalerie. Über die integrierte Online-Terminvereinbarung mit Calendly können Interessenten direkt Termine buchen. Lokales SEO sorgt für Sichtbarkeit in der Region.',
    result: 'Das Unternehmen wird als etablierter Fachbetrieb wahrgenommen. Die Webseite generiert kontinuierlich qualifizierte Anfragen aus der Region.',
    resultStats: [
      { label: 'Neue Aufträge', value: '+90%' },
      { label: 'Kundenzufriedenheit', value: '95%' },
      { label: 'Regionale Reichweite', value: '50km' },
    ],
    approachPoints: ['Umfangreiche Referenzgalerie', 'Online-Terminvereinbarung mit Calendly', 'Lokales SEO'],
    challengePoints: ['Keine Online-Sichtbarkeit', 'Fehlende Referenzen', 'Termine nur telefonisch'],
  },
  {
    id: 'ballettkinder',
    title: 'Wernigeröder Ballettkinder',
    headline: 'Kulturelle Leidenschaft digital zum Leben erweckt',
    url: 'https://www.ballettkinder-wr.de/',
    category: 'Förderverein',
    industry: 'Soziales & Vereine',
    description: 'Förderverein zur Unterstützung der Ballettschule Anna Kraus. Organisation von Aufführungen, Shows und Workshops.',
    summary: 'Lebendige Vereinswebseite mit Event-Kalender und Spendenmöglichkeit für kulturelle Nachwuchsförderung.',
    image: ballettkinderDesktop,
    screenshotDesktop: ballettkinderDesktop,
    color: 'from-fuchsia-500 to-pink-600',
    client: 'Förderverein Wernigeröder Ballettkinder e.V.',
    duration: '6 Wochen',
    services: ['Webdesign', 'Event-Kalender', 'Spendenintegration', 'Galerie', 'Hosting/Betrieb'],
    challenge: 'Der Förderverein hatte keine eigene Webpräsenz. Informationen zu Aufführungen und Workshops wurden nur über Aushänge und Mundpropaganda verbreitet. Spendenakquise war schwierig.',
    solution: 'Wir erstellten eine lebendige Webseite mit großer Bildergalerie vergangener Aufführungen. Ein Event-Kalender informiert über kommende Veranstaltungen. Die integrierte Spendenmöglichkeit macht die Unterstützung einfach.',
    result: 'Der Verein erreicht nun ein breiteres Publikum. Die Spenden haben zugenommen und Veranstaltungen sind regelmäßig ausverkauft.',
    resultStats: [
      { label: 'Mehr Spenden', value: '+75%' },
      { label: 'Event-Teilnahme', value: '+50%' },
      { label: 'Neue Förderer', value: '30+' },
    ],
    approachPoints: ['Lebendige Veranstaltungsgalerie', 'Event-Kalender-Integration', 'Spendentools'],
    challengePoints: ['Keine Webpräsenz', 'Schlecht erreichbar', 'Unzureichende Informationen'],
  },
  {
    id: 'eggert-alm',
    title: 'Eggert Alm Apartments',
    headline: 'Traumhafte Ferienwohnung perfekt in Szene gesetzt',
    url: 'https://www.eggert-alm.de/',
    category: 'Ferienwohnung',
    industry: 'Tourismus',
    description: 'Traumhaftes Apartment am idyllischen Ortsrand von Ilsenburg mit Blick auf den Harz. Für bis zu 6 Personen.',
    summary: 'Einladende Ferienwohnungs-Webseite mit emotionalen Bildern und nahtloser Buchungsintegration.',
    image: eggertAlmDesktop,
    screenshotDesktop: eggertAlmDesktop,
    color: 'from-sky-500 to-blue-600',
    client: 'Eggert Alm',
    duration: '5 Wochen',
    services: ['Webdesign', 'Buchungsintegration', 'Fotografie-Konzept', 'SEO', 'Hosting/Betrieb'],
    challenge: 'Das Apartment wurde nur über persönliche Empfehlungen vermietet. Eine eigene Webseite existierte nicht und die Auslastung hatte noch Potenzial.',
    solution: 'Wir erstellten eine emotionale Webpräsenz, die das Apartment und die traumhafte Umgebung erlebbar macht. Die integrierte Buchungsmöglichkeit vereinfacht die Reservierung. Ausflugstipps runden das Angebot ab.',
    result: 'Die Auslastung hat sich deutlich verbessert. Gäste sind begeistert von der detaillierten Präsentation und buchen oft vor der ersten Anfrage.',
    resultStats: [
      { label: 'Auslastung', value: '+80%' },
      { label: 'Buchungsrate', value: '85%' },
      { label: 'Wiederbuchungen', value: '45%' },
    ],
    approachPoints: ['Hochwertige Bildinszenierung', 'Detaillierte Beschreibungen', 'Nahtlose Buchung'],
    challengePoints: ['Fehlende Online-Vermarktung', 'Ungenutztes Potenzial', 'Direkte Buchungen kaum vorhanden'],
  },
  {
    id: 'elektro-gattermann',
    title: 'Elektro Gattermann',
    headline: 'Moderne Webseite für traditionsreichen Elektromeisterbetrieb',
    url: 'https://www.elektro-gattermann.de/',
    category: 'Handwerk',
    industry: 'Unternehmen & B2B',
    description: 'Elektro Gattermann – Ein Familienunternehmen seit 1932 mit umfassender Elektrofachkompetenz in der Region Wernigerode. 4-Tage-Woche, übertarifliche Bezahlung.',
    summary: 'Moderne Unternehmenswebseite mit Leistungsübersicht, Recruiting-Integration und Kontaktmöglichkeiten für einen etablierten Elektrofachbetrieb.',
    image: gattermannDesktop,
    screenshotDesktop: gattermannDesktop,
    color: 'from-blue-800 to-yellow-500',
    client: 'Elektro Gattermann GmbH',
    duration: '6 Wochen',
    services: ['Webdesign', 'Responsive Design', 'Recruiting-Integration', 'SEO', 'Hosting/Betrieb'],
    challenge: 'Der traditionsreiche Elektrofachbetrieb benötigte eine moderne Webpräsenz, um seine Leistungen, Erfahrung und Arbeitgeber-Benefits klar zu kommunizieren. Der Fachkräftemangel machte es zugleich schwierig, qualifizierte Mitarbeiter zu finden.',
    solution: 'Wir entwickelten eine benutzerfreundliche Unternehmenswebseite mit integriertem Recruiting-Bereich, die die Fachkompetenz und Zuverlässigkeit unterstreicht. Klare Navigationsstruktur, ansprechende Leistungsbeschreibungen, prominente Darstellung der Benefits (4-Tage-Woche, übertarifliche Bezahlung) und lokale SEO-Optimierung ermöglichen es potenziellen Kunden und Fachkräften, das Unternehmen leicht zu finden.',
    result: 'Die neue Webseite positioniert Elektro Gattermann als modernen, attraktiven Arbeitgeber und zuverlässigen Partner für Elektrofachleistungen. Die Anfragerate und qualifizierten Bewerbungen sind gestiegen und die Online-Sichtbarkeit in der Region deutlich verbessert.',
    resultStats: [
      { label: 'Mehr Bewerbungen', value: '+120%' },
      { label: 'Online-Anfragen', value: '+85%' },
      { label: 'Mobile Nutzung', value: '72%' },
    ],
    approachPoints: ['Moderne Corporate Identity', 'Integrierte Recruiting-Section', 'Lokale SEO-Optimierung', 'Responsive Mobile Design'],
    challengePoints: ['Veraltete Online-Präsenz', 'Geringe lokale Sichtbarkeit', 'Fachkräftemangel'],
  },
  {
    id: 'forsthaus-im-harz',
    title: 'Altes Forsthaus Eggeröder Brunnen',
    headline: 'Stimmungsvolle Webseite mit Smoobu-Direktbuchung für ein historisches Forsthaus im Harz',
    url: 'https://forsthaus-im-harz.de/',
    category: 'Ferienwohnungen',
    industry: 'Tourismus',
    description: 'Idyllisch gelegenes Forsthaus mitten im Harz – idealer Ausgangspunkt für Wanderungen, Mountainbiking und Auszeit in der Natur.',
    summary: 'Komplette Neuentwicklung mit WordPress und Elementor, Smoobu-Direktbuchung, Belegungskalender, Kontaktformular sowie stimmiger Bild- und Drohnenvideo-Inszenierung.',
    image: forsthausImHarzDesktop,
    screenshotDesktop: forsthausImHarzDesktop,
    color: 'from-emerald-800 to-green-600',
    client: 'Altes Forsthaus Eggeröder Brunnen',
    duration: '3 Monate',
    services: ['Webdesign', 'WordPress & Elementor', 'Smoobu-Integration', 'Belegungskalender', 'Kontaktformular', 'Drohnenvideo-Einbindung', 'Hosting/Betrieb'],
    challenge: 'Für das traditionsreiche Forsthaus mitten im Harz gab es keinen eigenständigen Webauftritt. Gäste konnten weder Verfügbarkeiten einsehen noch direkt buchen, und die besondere Atmosphäre des Ortes ließ sich online nicht erleben. Eine der ersten Webseiten, die wir gemeinsam mit dem Inhaber von Grund auf aufgebaut haben.',
    solution: 'Wir entwickelten eine komplett neue Webseite auf WordPress mit Elementor und integrierten Smoobu für die Direktbuchung. Ein eingebundener Belegungskalender zeigt Gästen jederzeit aktuelle Verfügbarkeiten, ein DSGVO-konformes Kontaktformular ermöglicht persönliche Anfragen. Stimmige Naturfotografie und ein eindrucksvolles Drohnenvideo machen die einzigartige Lage im Harz unmittelbar erlebbar.',
    result: 'Das Forsthaus präsentiert sich nun mit einem stimmungsvollen, eigenständigen Online-Auftritt. Gäste buchen provisionsfrei direkt über die Webseite, sehen Belegungen auf einen Blick und treten unkompliziert in Kontakt. Eine unserer ersten Seiten – und bis heute ein Aushängeschild für unsere Arbeit im Tourismus.',
    resultStats: [
      { label: 'Direktbuchungen', value: 'via Smoobu' },
      { label: 'Belegungskalender', value: 'Live' },
      { label: 'Drohnenvideo', value: 'Integriert' },
    ],
    approachPoints: ['WordPress mit Elementor', 'Smoobu-Direktbuchung', 'Live-Belegungskalender', 'Drohnenvideo & Naturfotografie', 'DSGVO-konformes Kontaktformular'],
    challengePoints: ['Kein eigener Webauftritt', 'Keine Online-Buchung möglich', 'Atmosphäre nicht erlebbar'],
  },
  {
    id: 'pasapa-kilanka',
    title: 'Pasapa Mensch und Beruf e.V. – Einführung Kilanka',
    headline: 'Eigenentwicklung durch moderne Fachsoftware Kilanka ersetzt – in rund sechs Monaten zum Go-live',
    url: 'https://www.kilanka.de/',
    urlLabel: 'Kilanka-Website ansehen',
    featured: true,
    category: 'Soziale Einrichtung',
    industry: 'Soziales & Vereine',
    description: 'pasapa Mensch und Beruf e.V. ist freier Träger der Kinder- und Jugendhilfe in Harzgerode und begleitet junge Menschen auf ihrem Weg in Beruf und Selbstständigkeit.',
    summary: 'Begleitung bei der Ablösung einer gewachsenen Eigenentwicklung durch die Fachsoftware Kilanka – von Prozessanalyse über Datenmigration bis zum produktiven Go-live.',
    image: pasapaDesktop,
    screenshotDesktop: pasapaDesktop,
    color: 'from-rose-700 to-orange-500',
    client: 'pasapa Mensch und Beruf e.V., Harzgerode',
    duration: 'ca. 6 Monate',
    services: ['Digitalisierungsberatung', 'Prozessanalyse', 'Auswahl Fachsoftware', 'Einrichtung Kilanka', 'Datenmigration', 'Testphasen & Schulung', 'Go-live-Begleitung'],
    challenge: 'Die über Jahre gewachsene Eigenentwicklung hatte gute Dienste geleistet, wurde aber nicht mehr aktiv weiterentwickelt. Jede Anpassung verursachte zusätzlichen Aufwand, neue gesetzliche und dokumentarische Anforderungen ließen sich nur noch schwer abbilden. Für eine Einrichtung, deren Alltag von verlässlicher Dokumentation und Verwaltung abhängt, war das keine tragfähige Perspektive.',
    solution: 'Wir haben pasapa über rund sechs Monate beim kompletten Wechsel auf die Fachsoftware Kilanka begleitet – von der Prozessanalyse über die Auswahl der Lösung, die Konfiguration der Module (Klientendokumentation, Mitarbeiterverwaltung, Dienstplanung, Arbeitszeit- und Urlaubsverwaltung, Dokumentenmanagement, Stammdaten) bis zur sorgfältig vorbereiteten Datenmigration aus der Alt-Datenbank. Tests in einer separaten Umgebung, direkte Abstimmung mit dem Kilanka-Support und die frühzeitige Einbindung der Mitarbeitenden sorgten für einen planbaren Go-live.',
    result: 'Der Wechsel verlief planmäßig und ohne Unterbrechung des laufenden Betriebs. Statt einer auslaufenden Eigenentwicklung steht heute eine moderne, kontinuierlich weiterentwickelte Fachsoftware zur Verfügung. Informationen laufen zentral zusammen, Mehrfacherfassungen entfallen und besonders die Klientendokumentation profitiert sichtbar von der einheitlichen Datenbasis.',
    resultStats: [
      { label: 'Projektdauer', value: 'ca. 6 Monate' },
      { label: 'Zentrale Plattform', value: 'Kilanka' },
      { label: 'Go-live ohne Ausfall', value: '0 Std.' },
    ],
    approachPoints: [
      'Prozessanalyse vor Softwareauswahl',
      'Bereinigte, geprüfte Datenmigration',
      'Testphasen mit den späteren Anwender:innen',
      'Direkte Abstimmung mit dem Kilanka-Support',
      'Begleitung über den Go-live hinaus',
    ],
    challengePoints: [
      'Auslaufende Eigenentwicklung ohne Weiterentwicklung',
      'Wachsende Dokumentations- und Verwaltungsanforderungen',
      'Komplexe, historisch gewachsene Datenbestände',
    ],
  },
  {
    id: 'ballettkinder-daeumelinchen',
    title: 'Förderverein Wernigeröder Ballettkinder e.V. – Einführung Onlineticketsystem',
    headline: 'Digitaler Ticketshop: Komplette Online-Abwicklung inkl. Integration von Zahlungsanbietern für Ballettvorstellungen',
    url: 'https://www.ballettkinder-wr.de/daeumelinchen-2026/',
    urlLabel: 'Ticketshop ansehen',
    category: 'Event-Ticketing',
    industry: 'Soziales & Vereine',
    featured: true,
    description: 'Der Förderverein Wernigeröder Ballettkinder e.V. – kann mit dem neuen Ticketsystem Ditix einfach und kostengünstig Karten für die jährlichen Veranstaltungen online verkaufen.',
    summary: 'Vollständiger Online-Ticketverkauf mit PayPal- und Stripe-Zahlung, automatischen Bestätigungen und Verwaltungs-Dashboard für den Förderverein.',
    image: ballettkinderTicketsDesktop,
    screenshotDesktop: ballettkinderTicketsDesktop,
    color: 'from-fuchsia-600 to-pink-500',
    client: 'Förderverein Wernigeröder Ballettkinder e.V.',
    duration: '2 Wochen',
    services: ['Ticketsystem', 'Zahlungsintegration (PayPal & Stripe)', 'Webdesign', 'Event-Marketing', 'Hosting/Betrieb'],
    challenge: 'Die Tickets für die Ballettvorstellungen des Fördervereins wurden bisher komplett analog verkauft: Bestellungen per Telefon, E-Mail und Papierlisten, Bezahlung bar oder per Überweisung. Das war für die ehrenamtlichen Helfer zeitaufwendig, fehleranfällig und bot weder eine Echtzeit-Übersicht noch eine bequeme Buchung aus Sicht der Eltern und Gäste.',
    solution: 'Wir haben einen vollständigen Online-Ticketshop in die bestehende Vereinswebseite integriert. Besucher können sich ihre Karten für die Vorstellungen im HKK Wernigerode direkt sichern und bequem per PayPal oder Kreditkarte bzw. Klarna (Stripe) bezahlen. Der Förderverein behält jederzeit den Überblick über Verkaufszahlen, Reservierungen und Zahlungseingänge – und die digitalen Tickets werden automatisch per E-Mail versandt.',
    result: 'Der Ticketverkauf startete erfolgreich: Am ersten Tag gingen bereits die Hälfte aller verfügbaren Karten über den neuen Shop. Der manuelle Abrechnungsaufwand sank deutlich, die Zahlungsabwicklung läuft sicher und die Besucher freuen sich über eine einfache, moderne Buchungserfahrung.',
    resultStats: [
      { label: 'Tickets verkauft Tag 1', value: '50%' },
      { label: 'Zahlungsarten', value: 'PayPal + Stripe' },
      { label: 'Buchungsaufwand', value: '-80%' },
    ],
    approachPoints: ['Online-Ticketverkauf', 'PayPal- & Stripe-Integration', 'Automatische Ticket-Bestätigungen', 'Verwaltungs-Dashboard'],
    challengePoints: ['Manueller Verkauf', 'Zahlung nur bar/Überweisung', 'Keine Echtzeit-Kontrolle'],
    datePublished: '2026-08-27',
    dateModified: '2026-08-27',
  },

];

export const industries = [
  'Alle',
  'Tourismus',
  'Gesundheit & Wellness',
  'Unternehmen & B2B',
  'Soziales & Vereine',
  'Immobilien',
];

export const getFeaturedReferences = () => references.filter(r => r.featured);
export const getAllReferences = () => references;
export const getReferenceById = (id: string) => references.find(r => r.id === id);
export const getRelatedReferences = (currentId: string, industry: string, limit = 2) => 
  references.filter(r => r.id !== currentId && r.industry === industry).slice(0, limit);
